import classNames from 'classnames';
import { Tab } from '../tab/tab.component';
import './sort.component.scss';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@gimlite/common';

export declare namespace SortType {
  type Props = {
    className?: string | null;
    disabled?: boolean;
  };
}

export const Sort = observer(({ className, disabled }: SortType.Props) => {
  const { t } = useTranslation();
  return (
    <div className={classNames('sort', className)}>
      <Tab disabled={disabled} icon="sort">
        {t('watermelon-sort')}
      </Tab>
    </div>
  );
});
